import { ReactElement, ReactNode } from 'react';

export interface IToolTipProps {
    children: ReactElement<any, any>;
    title: ReactNode;
    placement: Placement;
    withHtml?: boolean;
}

export enum Placement {
    topStart = 'top-start',
    top = 'top',
    topEnd = 'top-end',
    rightStart = 'right-start',
    right = 'right',
    rightEnd = 'right-end',
    bottomStart = 'bottom-start',
    bottom = 'bottom',
    bottomEnd = 'bottom-end',
    leftStart = 'left-start',
    left = 'left',
    leftEnd = 'left-end',
}
